import { React, useState, useEffect } from "react";
import Cards from "./Card";
import "../../styles/AdminDashboard.css";
import {
  getSingleQuery,
  onAdminDocumentsChange,
  requestQuery,
} from "../../apis/firestoreDatabase";
import { auth } from "../Firebase/Firebase";
import { useNavigate } from "react-router-dom";
import Loader from "../loader";
import Select from "react-select";
import "chart.js/auto";
import { Pie } from "react-chartjs-2";
import excel from "./images/excel.png";
import axios from "axios";
import { paymentStatuses, verificationStatuses } from "../../data/constants";
import { generateSubmissionID } from "../../data/utils";
// import ChartDataLabels from 'chartjs-plugin-datalabels';

function filterSubmissions({ arr, inputValue, FromDate, ToDate }) {
  //filter by search
  if (inputValue)
    arr = arr.filter(
      (element) =>
        element.PRN.indexOf(inputValue) != -1 ||
        element.candidateName.indexOf(inputValue) != -1
    );

  //filter by date
  if (FromDate && ToDate) {
    let from = new Date(FromDate);
    let to = new Date(ToDate);

    arr = arr.filter((element) => {
      let check = new Date(element.submissionTimestamp.toDate());
      return check >= from && check <= to;
    });
  }
  return arr;
}

async function downloadExcel(newarr, FromDate, ToDate, inputValue) {
  try {
    let arr = newarr.map((object) => ({ ...object }));

    arr = filterSubmissions({ arr, inputValue, FromDate, ToDate });

    //format dates
    arr = arr.map((element) => {
      if (element.submissionTimestamp)
        element.submissionTimestamp = element.submissionTimestamp
          ?.toDate()
          .toLocaleDateString("es-CL");
      delete element.submissionDate;
      return element;
    });

    console.log(arr);

    //download part
    const ll = "https://document-verification.rushour0.repl.co/downloadExcel";
    let response = await axios.post(
      ll,
      { params: arr },
      { responseType: "arraybuffer" }
    );

    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: "application/octet-stream" })
    );
    const link = document.createElement("a");

    link.href = url;
    const fname = "output.xlsx";

    link.setAttribute("download", fname);
    link.click();

    console.log(newarr);
  } catch (err) {
    console.log(err);
  }
}

const comparePaymentStatuses = (a, b) => {
  const { PAID, UNPAID, NOT_VERIFIED } = paymentStatuses;
  const paymentStatusOrder = [PAID, UNPAID, NOT_VERIFIED];
  return (
    paymentStatusOrder.indexOf(a.paymentStatus) -
    paymentStatusOrder.indexOf(b.paymentStatus)
  );
};

const compareStatuses = (a, b) => {
  const { VERIFIED, NOT_VERIFIED, DENIED } = verificationStatuses;
  const verificationStatusOrder = [NOT_VERIFIED, DENIED, VERIFIED];
  return (
    verificationStatusOrder.indexOf(a.status) -
    verificationStatusOrder.indexOf(b.status)
  );
};

export default function EventsItem() {
  const [queryArr, changeQueries] = useState([]);
  //removed seperate query ID list and added it back as a field to queryArr for easier handling

  let navigate = useNavigate();

  const [dashboardValues, setdashboardValues] = useState({
    totalQueries: 0,
    Completed: 0,
    Pending: 0,
    declined: 0,
  });

  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");

  const [inputValue, setInputValue] = useState("");
  const [stateLoader, setStateLoader] = useState("block");

  const [sortingMethod, ChangeSortingMethod] = useState("");

  const handleInputOnChange = (event) => {
    //console.log(event.target.value)
    setInputValue(event.target.value);
  };

  const updateChartData = (filteredQueryArr) => {
    let data = {
      totalQueries: 0,
      Completed: 0,
      Pending: 0,
      declined: 0,
    };

    filteredQueryArr.forEach((query) => {
      console.log(query);

      //For Calculating Total Number of Queries
      data.totalQueries++;

      //For Calculating Number of declined Queries
      if (query.status === verificationStatuses.DENIED) {
        data.declined++;
      }

      //For Calculating Number of Verified Queries
      else if (query.status === verificationStatuses.VERIFIED) {
        data.Completed++;
      } else if (query.status === verificationStatuses.NOT_VERIFIED) {
        data.Pending++;
      }
    });

    setdashboardValues(data);
  };

  //sort by filter useeffect
  useEffect(() => {
    if (!sortingMethod) return;

    let newarr = queryArr;
    console.log("sorting", { newarr }, "by: ", { sortingMethod });

    try {
      if (sortingMethod === "Date") {
        newarr.sort((a, b) => {
          return (
            new Date(b.submissionTimestamp.toDate()) -
            new Date(a.submissionTimestamp.toDate())
          );
        });
      }

      if (sortingMethod === "Name") {
        newarr.sort((a, b) => a.candidateName.localeCompare(b.candidateName));
      }

      if (sortingMethod === "QueryID") {
        newarr.sort((a, b) => {
          if (a.submissionID > b.submissionID) return 1;
          else if (a.submissionID == b.submissionID) return 0;
          else return -1;
        });
      }

      if (sortingMethod === "Payment Status") {
        newarr.sort(
          (a, b) => comparePaymentStatuses(a, b) || compareStatuses(a, b)
        );
      }

      if (sortingMethod === "Verification Status") {
        newarr.sort(
          (a, b) => compareStatuses(a, b) || comparePaymentStatuses(a, b)
        );
      }

      changeQueries([...newarr]); //newarr gets destroyed outside this useeffect, hence copying it by value
    } catch (err) {
      console.log(err);
    }
  }, [sortingMethod]);

  useEffect(() => {
    updateChartData(
      filterSubmissions({ arr: [...queryArr], inputValue, FromDate, ToDate })
    );
  }, [FromDate, ToDate, inputValue, queryArr]);

  const SortValue = [
    { label: "Date", value: 488 },
    { label: "Verification Status", value: 504 },
    { label: "Name", value: 500 },
    { label: "QueryID", value: 502 },
    { label: "Payment Status", value: 506 },
  ];

  const updateCards = async () => {
    try {
      // setStateLoader("block");
      const res = await requestQuery("verification.exam@mitwpu.edu.in");
      const temp = [];
      const tempId = [];
      res.forEach((doc) => {
        temp.push(doc.data());
        tempId.push(doc.id);
      });

      //add queryid to query array
      let newarr = [];

      for (let i = 0; i < temp.length; i++) {
        newarr.push({
          ...temp[i],
          queryId: tempId[i],
        });
      }

      changeQueries(newarr);
      setStateLoader("none");
      ChangeSortingMethod("Verification Status");
    } catch (err) {
      // setStateLoader("none");
      console.log(err);
    }
  };

  useEffect(async () => {
    // const userName=auth.currentUser
    updateCards();
    const unsub = onAdminDocumentsChange(updateCards);
    return unsub;
  }, []);

  async function logOut() {
    navigate("/");
    await auth.signOut();
  }

  return stateLoader === "block" ? (
    <Loader />
  ) : (
    <div id="mainDashBoardContainer">
      {/* <div id="DashBoard">
          <div
            className="DashBoardContainers"
            style={{ borderRight: "1px solid #DEDEDE" }}
          >
            <p className="headingDashboard">Total Queries</p>
            <p className="numbersDashboard">{dashboardValues.totalQueries}</p>
          </div>
          <div
            className="DashBoardContainers"
            style={{ borderRight: "1px solid #DEDEDE" }}
          >
            <p className="headingDashboard">Completed</p>
            <p className="numbersDashboard">{dashboardValues.Completed}</p>
          </div>
          <div
            className="DashBoardContainers"
            style={{ borderRight: "1px solid #DEDEDE" }}
          >
            <p className="headingDashboard">Pending</p>
            <p className="numbersDashboard">{dashboardValues.Pending}</p>
          </div>
          <div className="DashBoardContainers">
            <p className="headingDashboard">Declined</p>
            <p className="numbersDashboard">{dashboardValues.declined}</p>
          </div>
        </div> */}
      <div className="pieChart">
        <Pie
          data={{
            labels: ["Completed", "Pending", "Declined"],

            datasets: [
              {
                data: [
                  dashboardValues.Completed,
                  dashboardValues.Pending,
                  dashboardValues.declined,
                ],
                backgroundColor: [
                  "rgb(75,171,147)",
                  "rgb(54,162,235)",
                  "rgb(255,99,132)",
                ],
                borderColor: [
                  "rgb(255,255,255)",
                  "rgb(255,255,255)",
                  "rgb(255,255,255)",
                ],
                borderWidth: 1,
              },
            ],
          }}
          height={400}
          width={600}
          options={{
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
            plugins: {
              datalabels: {
                color: "white",
                font: {
                  size: 14,
                  weight: "bold",
                },
              },

              title: {
                display: true,
                text: "Query Status",
                position: "top",
                color: "white",
                font: { size: 25 },
              },
              legend: {
                labels: {
                  font: { size: 15 },
                  color: "white",
                },
              },
            },
            responsive: true,
          }}
        />
      </div>
      <div id="Admin-Info-container" className="Admin-flex">
        <div className="Admin-Option-details-container Admin-flex">
          <div
            className="Option-detail Admin-flex"
            style={{ marginLeft: "2%" }}
          >
            <p className="Info-property">SortBy</p>
            <Select
              options={SortValue}
              onChange={(e) => ChangeSortingMethod(e.label)}
              placeholder="Select"
              styles={{ color: "#787878" }}
            />
          </div>
          <div className="Option-detail Admin-flex">
            <p className="Info-property">From</p>
            <input
              type="date"
              className="Admin-select-date"
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="Option-detail Admin-flex">
            <p className="Info-property">To</p>
            <input
              type="date"
              className="Admin-select-date"
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="Option-detail Admin-flex">
            <input
              type="search"
              className="Admin-Info-search"
              placeholder="Search Here"
              value={inputValue}
              onChange={handleInputOnChange}
            />
          </div>
        </div>

        <div className="downloadExcel">
          <button
            className="downloadExcelbtn"
            onClick={() => {
              downloadExcel([...queryArr], FromDate, ToDate, inputValue);
            }}
          >
            <img src={excel} className="excelLogo" alt="downloadExcel" />
          </button>
        </div>

        <div className="Admin-Logout-btn-container Admin-flex">
          <button className="Admin-Logout-btn" onClick={() => logOut()}>
            Logout
          </button>
        </div>
      </div>
      <div id="Main_Item_Container_admin">
        <div className="main_card_container mainHeaderContainer">
          <h2 className="Admin-heading"> Date Received </h2>
          <h2 className="Admin-heading"> Query Id </h2>
          <h2 className="Admin-heading"> Name </h2>
          <h2 className="Admin-heading"> PRN </h2>
          <h2 className="Admin-heading"> Payment </h2>
          <h2 className="Admin-heading" id="btnHeading">
            Option-details
          </h2>
        </div>
        {queryArr.map((element, i) => {
          if (
            element.PRN.indexOf(inputValue) == -1 &&
            element.candidateName.indexOf(inputValue) == -1
          )
            //search filter, name and prn
            return <></>;

          //filter according to date range
          if (FromDate && ToDate) {
            let from = new Date(FromDate);
            let to = new Date(ToDate);

            //console.log(from,to);

            let check = new Date(element.submissionTimestamp.toDate());
            //console.log(check);

            if (check < from || check > to) return <></>;
          }

          return (
            <>
              <Cards
                key={element.queryId}
                date={element.submissionTimestamp
                  ?.toDate()
                  .toLocaleDateString("es-CL")}
                docs={element.Documents}
                email={element.Email}
                NEFT={element.NEFTrefNumber}
                prn={element.PRN}
                PYear={element.PassingYear}
                Prog={element.Program}
                Uni={element.Univerity}
                compContactNumber={element.companyContactNumber}
                compContactPersonal={element.companyContactPersonal}
                CompEmail={element.companyEmail}
                CompName={element.companyName}
                queryId={element.queryId}
                name={element.candidateName}
                status={element.status}
                statusDate={element.statusDate}
                owner={element.owner}
                paymentStatus={element.paymentStatus}
                certFilename={element.certFilename}
                submissionID={generateSubmissionID(element)}
                color={
                  i % 2 === 0
                    ? "rgba(255, 255, 255, 0.2)"
                    : "rgba(0, 0, 0, 0.1)"
                }
              />
            </>
          );
        })}
      </div>
    </div>
  );
}
